export default __webpack_public_path__ + "static/media/37.cffafe6b.jpg";